import { render, staticRenderFns } from "./ApplyDetail.vue?vue&type=template&id=3788b8df&"
import script from "./ApplyDetail.vue?vue&type=script&lang=js&"
export * from "./ApplyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports